import CopyToClipboardView from "@/components/views/CopyToClipboardView";
import { formatLocaleDate } from "@/utils/formatUtils";
import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import { NaturalAgent, NaturalSecondaryAgent, SelfEmployedAgent, SelfEmployedSecondaryAgent } from "../../types";

type PersonalDataProps = {
  agent: NaturalSecondaryAgent | SelfEmployedSecondaryAgent | NaturalAgent | SelfEmployedAgent;
  width?: number;
};

export const PersonalData = ({ agent, width }: PersonalDataProps) => {
  const { t } = useTranslation();

  return (
    <Descriptions
      size="small"
      bordered
      column={1}
      styles={{ label: { width: width ?? 250 } }}
      items={[
        {
          label: t("agent.attrs.personalIdentificationNumberLong"),
          children: <CopyToClipboardView content={agent.personalIdentificationNumber} />,
        },
        {
          label: t("agent.attrs.birthDate"),
          children: formatLocaleDate(agent.birthDate),
        },
        {
          label: t("agent.attrs.identityCardNumber"),
          children: <CopyToClipboardView content={agent.identityCardNumber} />,
        },
        {
          label: t("common.enums.educationLevel._label"),
          children: agent.educationLevel ? t(`common.enums.educationLevel.${agent.educationLevel}`) : undefined,
        },
      ]}
    />
  );
};
